import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p10} from "../../../layouts/ch5_p10/ch5_p10";

export class Chapter5Page10 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly treeBack = this.addChild(new SceneSprite());
    readonly branch = this.addChild(new SceneSprite());
    readonly bird = this.addChild(new SceneSprite());

    readonly treeFront = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly balloonPink = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly balloonYellow = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly balloonRed = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];

    readonly popBack = this.addChild(new SceneSprite());
    readonly popFront = this.addChild(new SceneSprite());
    readonly pop = this.addChild(new SceneSprite());
    readonly actionLines = this.addChild(new SceneSprite());
    readonly piece = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];;

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p10/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p10/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p10/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p10/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p10.call(this);

		// super.init calls onResize
        super.init(pSize, pData);

        // TODO: find a better way to preserve layer order
        this.setChildIndex(this.balloonPink[1], this.getChildIndex(this.treeBack));

        this.balloonPink[1].visible = false;
        this.balloonYellow[1].visible = false;
        this.balloonRed[1].visible = false;

        this.pop.visible = false;
        this.popBack.visible = false;
        this.popFront.visible = false;
        this.actionLines.visible = false;
        this.piece.forEach(p=>p.visible = false);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);

        // fade out old background music
		const prevLoop = Application.instance.audio.getAudioTrack("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", HLF.AudioCategory.BGM);
		prevLoop?.fadeTo(0, 1000);
		prevLoop?.once(HLF.HowlerUtils.Events.FADE, ()=>{
			prevLoop.unloadSource();
		});

        Application.instance.audio.play("HH_Ch5_Balloon_Tension_P10-11", 1, false, HLF.AudioCategory.BGM);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=> {
                this.balloonPink[0].FadeOut();
                this.balloonYellow[0].FadeOut();
                this.balloonRed[0].FadeOut();

                this.balloonPink[1].FadeIn();
                this.balloonYellow[1].FadeIn();
                this.balloonRed[1].FadeIn();
            })
            .call(()=>{
                this.balloonPink[1].FadeOut();
                this.pop.FadeIn();
                this.popBack.FadeIn();
                this.popFront.FadeIn();
                this.actionLines.FadeIn();
                this.piece.forEach(p=>p.FadeIn());
            }, undefined, undefined, 2)
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "left"});
            }, undefined, undefined, "+=1.5")
            .delay(1)
        ;
    }
}